export default "__VITE_ASSET__Bwt1YviD__"